import React from 'react';
import { Link } from 'react-router-dom';

interface MenuItem {
  label: string;
  href?: string;
}

interface DesktopNavigationProps {
  menuItems: MenuItem[];
  isActiveItem: (item: MenuItem) => boolean;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
  menuItems,
  isActiveItem,
}) => {
  return (
    <nav className="hidden md:flex items-center justify-center space-x-1">
      {menuItems.map((item) => (
        <div key={item.label} className="relative">
          {item.href ? (
            <Link
              to={item.href}
              className={`px-4 py-2 text-base font-medium transition-all duration-200 cursor-pointer relative ${
                isActiveItem(item)
                  ? 'text-primary-500 border-b-2 border-secondary-900'
                  : 'text-secondary-900 hover:border-b-2 hover:border-secondary-900 hover:text-primary-500'
              }`}
            >
              {item.label}
            </Link>
          ) : (
            <span className="px-4 py-2 text-base font-medium text-secondary-900">
              {item.label}
            </span>
          )}
        </div>
      ))}
    </nav>
  );
};

export default DesktopNavigation;
